/** @jsxImportSource react */
import { useEffect } from 'react'
import { useBlocker } from 'react-router-dom'
import ConfirmDialog from '../components/common/ConfirmDialog'

/** Pass as navigate(to, SKIP_GUARD) when leaving right after a successful save. */
export const SKIP_GUARD = { state: { skipUnsavedGuard: true } }

/**
 * Warns before losing unsaved changes: browser tab close/reload (native prompt) and in-app
 * navigation (dialog). Returns the dialog element to render.
 */
export const useUnsavedChangesGuard = (dirty, message = 'You have unsaved changes. Leave without saving?') => {
  useEffect(() => {
    if (!dirty) return undefined
    const handler = (e) => {
      e.preventDefault()
      e.returnValue = ''
    }
    window.addEventListener('beforeunload', handler)
    return () => window.removeEventListener('beforeunload', handler)
  }, [dirty])

  const blocker = useBlocker(({ currentLocation, nextLocation }) =>
    dirty
    && !nextLocation.state?.skipUnsavedGuard
    && (currentLocation.pathname !== nextLocation.pathname || currentLocation.search !== nextLocation.search))

  return (
    <ConfirmDialog
      open={blocker.state === 'blocked'}
      title="Discard changes?"
      message={message}
      confirmLabel="Leave"
      destructive
      onConfirm={() => blocker.proceed?.()}
      onClose={() => blocker.reset?.()}
    />
  )
}
